<template>
	<div :style="shu.yangshi" class="zidingyi_wenzi">{{shu.wenzi?shu.wenzi:'输入文字'}}</div>
</template>

<script>
	export default {
		name: 'wenzi',
		props: {
			shu: {
				type: Object,
				default () {
					return {}
				}
			}
		},

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
